import React from "react";
import { Link } from "react-router-dom";
//import "react-tooltip/dist/react-tooltip.css";

interface Props {
  PaintingId: string;
  PaintingName: string;
  PaintingPath: string;
  IsSold: boolean;
  Title: string;
  Medium: string;
  Price: number;
  Size: string;
  DateCreated: string;
  ThumbPath: string;
  Discount: number;
  DiscountPrice: number;
}

interface State {
  renderCount: number;
  isLoading: boolean;
}

class Painting extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      renderCount: 0,
      isLoading: false,
    };
  }

  render() {
    let fullPath: string = this.props.ThumbPath + this.props.PaintingName;
    return (
      <div className="col-md-4">
        <div className="card card-product card-plain">
          <div className="card-image">
            <Link
              id={"painting_" + this.props.PaintingId}
              to={`../paintingdetails/` + this.props.PaintingId}
            >
              <img
                src={fullPath}
                alt=""
                className="img-rounded img-responsive"
              />
            </Link>

            <div className="card-body">
              <div className="card-description">
                <Link
                  id={"painting_" + this.props.PaintingId}
                  to={`../paintingdetails/` + this.props.PaintingId}
                >
                  <h5 className="card-title">{this.props.Title}</h5>
                </Link>

                <p className="card-description">Medium: {this.props.Medium}</p>
                <p className="card-description">Size: {this.props.Size} (cm)</p>
              </div>
              {this.props.IsSold ? (
                <div className="price">
                  <span className="badge badge-pill badge-red">&nbsp;</span>
                  <span className="text-danger">Sold</span>
                </div>
              ) : this.props.Discount > 0 ? (
                <div className="price">
                  <s>£{this.props.Price}</s>&nbsp;
                  <strong>£{this.props.DiscountPrice}</strong>
                  <span className="text-danger"> - {this.props.Discount}%</span>
                </div>
              ) : (
                <div className="price">
                  <strong>£ {this.props.Price}</strong>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Painting;
